import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "w-100 h-100 error-state d-flex justify-content-center align-items-center flex-grow-1 flex-column" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Error", -1 /* HOISTED */)
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Please try again or submit a ticket for assistance. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h6", _hoisted_3, [
      _createElementVNode("span", null, " An error occurred while " + _toDisplayString(_ctx.action) + " " + _toDisplayString(_ctx.title) + ". ", 1 /* TEXT */),
      _hoisted_4
    ]),
    (_ctx.showTryAgain)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.tryAgain?.()))
        }, "Try Again"))
      : _createCommentVNode("v-if", true)
  ]))
}